module.exports = __webpack_public_path__ + "img/candle.232c4e13.png";